var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('md-button',{class:_vm.buttonClass,on:{"click":_vm.add}},[_c('md-icon',[_vm._v("add_box")]),_vm._v("\n  "+_vm._s(_vm.text)+"\n")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }